<template>
    <v-layout column>
        <v-flex xs12 v-if="cartItems.length > 0">
            <v-flex v-if="!showStoreList">
                <div class="text-xs-left">
                    <v-btn
                            flat
                            @click="goBack"
                    >
                        <v-icon left small>fal fa-chevron-left</v-icon>
                        {{ $vuetify.t('$vuetify.back') }}
                    </v-btn>
                </div>
            </v-flex>

            <v-flex xs12 v-if="cartItemsNoStock===1 && !showStoreList">

                <v-list>
                    <v-list-tile class="alert-list-tile">
                        <v-list-tile-avatar>
                            <v-icon class="error--text">fas fa-exclamation-triangle</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title class="error--text">
                                {{ $vuetify.t('$vuetify.shop.shop_cart_items_unavailable') }}
                            </v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action class="text-xs-center hidden-sm-and-down">
                            <v-btn color="error"
                                   @click="removeItemsNoStock"
                                   flat
                                   medium
                                   class="shop-cart-removeall">
                                {{ $vuetify.t('$vuetify.removeall') }}
                                <v-icon right small>fal fa-trash</v-icon>
                            </v-btn>
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list>
                <v-flex xs12 class="text-xs-center hidden-md-and-up">
                    <v-btn color="error"
                           @click="removeItemsNoStock"
                           flat
                           medium
                           class="shop-cart-removeall">
                        {{ $vuetify.t('$vuetify.removeall') }}
                        <v-icon right small>fal fa-trash</v-icon>
                    </v-btn>
                </v-flex>
            </v-flex>
            <v-flex xs12 v-if="!showStoreList" class="shop-resume-items">
                <v-expansion-panel :value="itemsPanel">
                    <v-expansion-panel-content :readonly="false" :hide-actions="false"
                                               style="background:transparent">
                        <template v-slot:header>
                            <h2 class="primary--text">
                                {{ $vuetify.t('$vuetify.items') }}
                            </h2>
                        </template>
                        <!--                        <ItemsListCard v-if="cartHasMenu"-->
                        <!--                                       :items="cartItems">-->
                        <!--                        </ItemsListCard>-->
                        <ItemsList
                                :items="cartItems"
                                :displayEditQuantity=false
                                :displayRemove=false>
                        </ItemsList>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-flex>

            <v-flex xs12 v-if="!showStoreList" class="shop-resume-delivery">
                <v-expansion-panel :value="deliveryPanel">
                    <v-expansion-panel-content :readonly="true" :hide-actions="true"
                                               style="background:transparent">
                        <template v-slot:header>
                            <h2 class="primary--text">
                                {{ $vuetify.t('$vuetify.shop.shipping_method') }}
                            </h2>
                        </template>
                        <v-card style="background:transparent">
                            <v-card-text>
                                <span class="title shop-resume-delivery-method font-weight-bold"> {{
                                        deliveryInfo.method_title
                                    }}</span>
                                <br>
                                <v-icon v-if="deliveryInfo.store.name" color="secondary" class="pt-2">fal fa-map-pin
                                </v-icon>
                                <span @click="showStoreList = true" v-if="deliveryInfo.store.name"
                                      class="title secondary--text shop-delivery-location pl-2">
                                    {{ deliveryInfo.store.name }}
                                </span>
                                <br>
                                <v-icon v-if="deliveryInfo.store.address" small color="grey" class="pt-2">
                                    fal fa-map-marked-alt
                                </v-icon>
                                <span v-if="deliveryInfo.store.address" class="pl-2 grey--text">
                                    {{ deliveryInfo.store.address }}
                                </span>
                                <br>
                                <v-icon v-if="deliveryInfo.store.schedule" small color="grey" class="pt-2">
                                    fal fa-clock
                                </v-icon>
                                <span v-if="deliveryInfo.store.schedule" class="pl-2 grey--text">
                                    {{ deliveryInfo.store.schedule }}
                                </span>
                            </v-card-text>
                        </v-card>
                        <!--                        <v-card style="background:transparent; text-align: center">-->
                        <!--                            <v-card-text>-->
                        <!--                                <p>A sua encomenda está disponível para levantamento no prazo máximo de 24 horas.</p>-->
                        <!--                            </v-card-text>-->
                        <!--                        </v-card>-->

                        <v-card style="background:transparent; text-align: center">
                            <v-card-text>
                                <v-radio-group v-model="deliveryOptionsTime" :mandatory="true"
                                               v-on:change="deliveryOptionsTimeSelect">
                                    <!-- TODO Parametrizar MSG -->
                                    <v-radio v-if="deliveryOptionsTimeDisplayNow"
                                             label="Encomenda disponível para levantamento no prazo máximo de 48 horas"
                                             value="now"></v-radio>
                                    <v-spacer></v-spacer>
                                    <v-radio v-if="deliveryOptionsTimeDisplayChoose"
                                             v-bind:label="$vuetify.t('$vuetify.shop.order_resume_choose_date')"
                                             value="choose"></v-radio>
                                </v-radio-group>
                                <v-menu v-if="displayCalendar"
                                        ref="menu"
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        :return-value.sync="date"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                                v-model="date"
                                                prepend-icon="fal fa-calendar-alt"
                                                readonly
                                                v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date" no-title scrollable
                                                   :min="dateMin"
                                                   :max="dateMax"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                                        <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                                    </v-date-picker>
                                </v-menu>
                                <!-- TODO Ivo: validar dimensões do componente de hora de levantamento-->
                                <v-menu v-if="displayCalendar"
                                        ref="menu2"
                                        v-model="menu2"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        :return-value.sync="time"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                                v-model="time"
                                                prepend-icon="fal fa-clock"
                                                readonly
                                                v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-time-picker
                                            v-model="time"
                                            full-width
                                            @click:minute="$refs.menu2.save(time)"
                                    ></v-time-picker>
                                    <!--                                            min="9:30"-->
                                    <!--                                            max="22:15"-->
                                </v-menu>
                            </v-card-text>
                        </v-card>

                        <v-card style="background:transparent; text-align: center">
                            <v-card-text>
                                <v-text-field
                                        v-model="obs"
                                        prepend-icon="fal fa-comments"
                                        v-bind:label="$vuetify.t('$vuetify.shop.order_resume_comments')"
                                        regular
                                        counter
                                        :maxlength="maxObsLength"
                                ></v-text-field>
                            </v-card-text>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-flex>

            <v-divider v-if="!showStoreList" class="my-2 grey lighten-2"></v-divider>

            <v-flex v-if="!showStoreList" offset-sm4 offset-md6 offset-lg8>
                <v-list>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                <h4>{{ $vuetify.t('$vuetify.items') }}</h4></v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <h4>
                                {{ cartTotalAmount }}&nbsp;{{ currencySymbol }}
                            </h4>
                        </v-list-tile-action>
                    </v-list-tile>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                <h4>{{ $vuetify.t('$vuetify.shop.shipping_costs') }}</h4>
                            </v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <h4>0&nbsp;{{ currencySymbol }}</h4>
                        </v-list-tile-action>
                    </v-list-tile>
                    <v-list-tile class="primary--text">
                        <v-list-tile-content>
                            <v-list-tile-title>
                                <h2>{{ $vuetify.t('$vuetify.total') }}</h2>
                            </v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <h2>{{ cartTotalAmount }}&nbsp;{{ currencySymbol }}</h2>
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list>
            </v-flex>
            <v-flex xs12 v-if="!showStoreList">
                <div class="text-xs-center">
                    <v-btn v-if="Object.keys(paymentOptions).length > 0"
                            :disabled=!isEnabled
                            @click="pay"
                            class="primary"
                            large
                    >
                        {{ $vuetify.t('$vuetify.shop.shop_cart_pay') }}
                        <v-icon right small>fal fa-angle-double-right</v-icon>
                    </v-btn>
                    <v-btn v-else
                            :disabled=!isEnabled
                            @click="submit"
                            class="primary"
                            large
                    >
                        {{ $vuetify.t('$vuetify.shop.shop_cart_submit') }}
                        <v-icon right small>fal fa-angle-double-right</v-icon>
                    </v-btn>
                </div>
            </v-flex>
            <v-flex xs12 v-if="showStoreList">
                <h2 class="primary--text">
                    {{ $vuetify.t('$vuetify.shop.shipping_location') }}
                </h2>
                <StoresListComp
                        @selected="handleStoreSelected"
                        :displayImage=false
                        :displayGoToDetail=false
                        :select=true
                        :selectedStoreId="selectedStore ? selectedStore.id : selectedStore"
                        :referenceLocation="locationCoords"></StoresListComp>
            </v-flex>
        </v-flex>
        <v-flex xs12 v-else>
            <v-layout align-center justify-center column>
                <v-spacer class="my-4"></v-spacer>
                <v-icon style="font-size: 150px">fal fa-shopping-cart</v-icon>
                <v-spacer class="my-4"></v-spacer>
                <h2 class="title text-xs-center">{{ $vuetify.t('$vuetify.shop.shop_cart_empty') }}</h2>
                <v-spacer class="my-4"></v-spacer>
                <div class="text-xs-center">
                    <v-btn
                            @click="goTo"
                            class="primary"
                            large
                    >
                        {{ $vuetify.t('$vuetify.shop.buy') }}
                        <v-icon right small>fal fa-angle-double-right</v-icon>
                    </v-btn>
                </div>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {genericService} from '@/_services/shop/generic.service';
    import {getErrorMessage, getLocation, recaptchaHelper} from '@/_helpers';
    import ItemsList from '@/components/ItemsList.vue';
    // import ItemsListCard from '@/components/ItemsListCard.vue';
    import StoresListComp from '@/components/StoresListComp.vue';


    export default {
        name: "OrderStepResume",
        components: {ItemsList, StoresListComp},
        data() {
            return {
                customer: {},
                deliveryPanel: 0,
                showStoreList: false,
                locationCoords: null,
                selectedStore: null,
                deliveryOptionsTime: 'now',
                deliveryOptionsTimeDisplayNow: false,
                deliveryOptionsTimeDisplayChoose: true,
                date: new Date().toISOString().substr(0, 10),
                dateMin: null,
                dateMax: null,
                menu: false,
                menu2: false,
                displayCalendar: false,
                obs: null,
                maxObsLength: 40,
                time: null,
                paymentOptions: [],
            }
        },
        methods: {
            /**
             * The method which sends to the backend the necessary data to create the Order.
             **/
            submit() {
                // 1 - setting the Loading Layer
                this.$store.dispatch("loader/setLoading", true);

                // 2 - an object is defined with all the information which will be passed to the backend
                let obj = {
                    "items": this.cartItems,
                    "shipping_method": this.deliveryInfo.method_key,
                    "shipping_pickup_store": this.deliveryInfo.store.code,
                    "date": this.date,
                    "hour": this.time,
                    "obs": this.obs
                };
                // 3 - sending the items on the Shopping Cart to create the Order on the backend
                // Once the Order is successfully created, the local storage is "cleaned" and
                // the user is redirected to the list of his Orders.
                recaptchaHelper('setCustomerPurchase', this).then((token) => {
                        obj.recaptcha_token = token;
                        genericService.setCustomerPurchase(obj).then(result => {
                                //Example of result: {'status': response_status, 'error': error_code, 'order': order_code},
                                if (result && result.status && result.status === 1) {
                                    this.$log.debug("Order Step Resume | Set Customer Purchase | " + result);
                                    this.$store.dispatch("alert/success", this.$vuetify.t('$vuetify.shop.order_successfully_submited'));
                                    this.$store.dispatch('shop/setShopCartEmpty');
                                    this.$store.dispatch('shop/setDeliveryOptionsEmpty');
                                    this.$router.push({name: "orders"});
                                } else if (result && result.status === 0 && result.error === "Err101") {
                                    this.$store.dispatch("alert/error", this.$vuetify.t('$vuetify.shop.exceeded_daily_orders'));

                                } else {
                                    this.$store.dispatch("alert/error", this.$vuetify.t('$vuetify.generic_error'));
                                }

                                this.$store.dispatch("loader/setLoading", false);
                            },
                            error => {
                                getErrorMessage(error, 'Set Customer Purchase', this);
                            });
                    },
                    error => {
                        getErrorMessage(error, 'Set Customer Purchase Recaptcha', this);
                    });
            },
            /**
             * The method assigned to the button which allows the user to return to the interface to choose the
             * Delivery Options
             **/
            goBack() {
                this.$router.push({name: "order-delivery"});
            },
            // /**
            //  * If the Item has no stock on the selected shop, the user has to remove it from the Shopping Cart, prior
            //  * to submit the Order. This is the method called to remove an Item from the cart.
            //  **/
            // removeItem(itemId) {
            //     this.$store.dispatch("shop/deleteFromCart", itemId);
            // },
            /**
             * If the Item has no stock on the selected shop, the user has to remove it from the Shopping Cart, prior
             * to submit the Order. If there are a lot of Items in this condition, the user has the option to
             * remove all the unavailable Items at the same time. This is the method called to remove all the
             * unavailable Items from the Shopping Cart.
             **/
            removeItemsNoStock() {
                for (var i = 0; i < this.cartItems.length; i++) {
                    if (this.cartItems[i].stock === 0) {
                        let itemId = this.cartItems[i].item_id;
                        this.$store.dispatch("shop/deleteFromCart", {itemId,});
                    }
                }
            },
            /**
             * The method assigned to the button which is displayed once the Shopping Cart is empty. This button
             * redirects the user to the Catalog
             **/
            goTo() {
                this.$router.push({name: "catalog"});
            },
            /**
             * The Delivery option "Store Pick Up" requires the user to select a Store to collect the Order.
             * This method is called when the user selects the Store. This way, a local variable is set with the
             * selected Store.
             * Also the flag to display/hide the list of Stores is set to False, so the list is set to hidden.
             **/
            handleStoreSelected(store) {
                this.$store.dispatch("shop/setDeliveryOptions", {
                    'methodKey': this.deliveryInfo.method_key,
                    'methodTitle': this.deliveryInfo.method_title,
                    'shop': store
                });
                this.selectedStore = store;
                this.showStoreList = false;
                let obj = {
                    "items": this.cartItems,
                    "shipping_pickup_store": this.selectedStore.code
                };
                //
                recaptchaHelper('validateCustomerPurchase', this).then((token) => {
                        obj.recaptcha_token = token;
                        genericService.validateCustomerPurchase(obj).then(result => {
                                this.$store.dispatch('shop/setShopCart', result);
                                this.$store.dispatch("loader/setLoading", false);
                            },
                            error => {
                                getErrorMessage(error, 'Set Customer Purchase', this);
                            });
                    },
                    error => {
                        getErrorMessage(error, 'Validate Customer Purchase Recaptcha', this);
                    });
            },
            /**
             *
             **/
            deliveryOptionsTimeSelect(option) {
                if (option === 'choose') {
                    this.displayCalendar = true;
                    this.date = this.dateMin;
                } else {
                    this.displayCalendar = false;
                    this.date = null;
                }
            },
            /**
             * The User is redirected to the interface where it is possible to choose the Payment method to pay the
             * Customer Purchase
             *
             **/
            pay() {
                this.$router.push({name: "order-pay", params: {"date": this.date, "hour": this.time, "obs": this.obs}});
            },
        },
        computed: {
            /**
             * The function which validates if the user can submit his Order.
             * The condition to enable the Order's submission:
             * the Shopping Cart can't have unavailable Items (Items with no stock)
             *
             * @returns {boolean}
             */
            isEnabled() {
                return this.cartItemsNoStock !== 1 && (this.obs && this.obs.length <= this.maxObsLength || !this.obs);
            },
            /**
             * The panel which groups all the Items on the Shopping Cart can be loaded open or closed. This definition
             * is set based on whether the Items on the Shopping Cart are all available or not.
             * @returns {Array|number}
             */
            itemsPanel: function () {
                if (this.cartItemsNoStock === 1) {
                    //Panel Opened
                    return 0;
                } else {
                    //Panel Closed
                    return [];
                }
            },
            ...mapGetters({
                cartItems: 'shop/cartItems',
                cartTotalItems: 'shop/cartSize',
                cartTotalAmount: 'shop/cartTotalAmount',
                cartItemsNoStock: 'shop/cartItemsNoStock',
                deliveryInfo: 'shop/deliveryInfo',
                cartHasMenu: 'shop/cartHasItemMenu',
                currencySymbol: 'configs/currencySymbol',
                baseUrl: 'configs/apiImgBaseUrl',
            })
        },
        mounted() {
            //https://developer.mozilla.org/pt-BR/docs/Web/API/Position
            //Getting user's current geo location
            if (navigator.geolocation) {
                this.locationCoords = getLocation(navigator.geolocation);
            }

            //
            this.dateMin = new Date();
            this.dateMin.setDate(this.dateMin.getDate());
            //TODO parametrizar data minima
            //this.dateMin.setDate(this.dateMin.getDate() + 2);
            this.dateMin = this.dateMin.toISOString().substr(0, 10);
            this.date = this.dateMin;

            //
            if (this.deliveryOptionsTimeDisplayNow) {
                this.deliveryOptionsTime = 'now'
            } else {
                this.deliveryOptionsTime = 'choose'
            }

            var date = new Date(new Date().getTime() + 10 * 60000);
            this.time = ((date.getHours() < 10) ? "0" : "") + date.getHours() + ":" + ((date.getMinutes() < 10) ? "0" : "") + date.getMinutes();

            this.deliveryOptionsTimeSelect(this.deliveryOptionsTime);

            genericService.getPaymentOptions().then(result => {
                    this.paymentOptions = result.results[0].payment_methods;
                    this.$store.dispatch("loader/setLoading", false);
                },
                error => {
                    getErrorMessage(error, 'Getting the Payment Options', this);
                }
            );

        }
    }
</script>

<style scoped>

</style>